import React from "react";
import Box from "@mui/material/Box";
import { BigHeadline } from "../../components/TextParts";
import RecruitmentRegistrationSampleSelection from "./template/recruitmentRegistrationSampleSelection";

export default function RecruitmentRegistrationSample() {
  return (
    <Box>
      <BigHeadline text="募集登録入力サンプル" />
      <RecruitmentRegistrationSampleSelection />
    </Box>
  );
}